<template>
<transition name="slide">
  <div class="sider" v-if="visible">
      <slot></slot>
      <!-- <button @click="visible=!visible">close</button> -->
  </div>
</transition>
</template>

<script>
export default {
  name:'KilokSider',
  data(){
    return{
      visible:true
    }
  },
 
}
</script>

<style lang="scss" scoped>
$background-1: rgb(13, 87, 172);
.sider{
   display: flex;
  justify-content: center;
  align-items: center;
  background-color: $background-1;
  width: 100px;
  position: relative;
  >button{
    position: absolute;
    top: 0;
    right: 0;
  }
}
.slide-enter-active, .slide-leave-active {
  transition: all .5s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
  margin-left: -200px;
}
</style>